import { Toaster as Sonner, type ToasterProps, toast } from "sonner";

/**
 * Sonner toaster styled like the demo `.toast` (navy body, red on error).
 * Pass `theme="dark"` from the admin shell when dark mode is active.
 */
function Toaster({ theme = "light", ...props }: ToasterProps) {
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast !bg-navy !text-white !border-0 !rounded-lg !shadow-[0_4px_16px_#0003] data-[type=error]:!bg-destructive",
          description: "!text-white/80",
          actionButton: "!bg-gold !text-navy",
          cancelButton: "!bg-white/15 !text-white",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast };
